import { render, staticRenderFns } from "./InstitucionesComponent.vue?vue&type=template&id=ca7cbdb6"
import script from "./InstitucionesComponent.vue?vue&type=script&lang=js"
export * from "./InstitucionesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports